<div class="form-holder" *ngIf="accountManagement$ | async as accountManagement">
    <!-- <div class="form-header">
        <span class="form-title"></span>
    </div> -->
    <div class="form-content deletion-form-holder form-visible">
        <div class="row">
            <div class="col-12">
                <serviceos-ng-link
                    *ngIf="(deleteAccountRequested | async) === false; else accountDeletionRequested"
                    [type]="'primary'"
                    [size]="'small'"
                    [font_weight]="'semi-bold'"
                    (click)="onDeleteAccountClick()"
                >
                {{ accountManagement.request_button_title }}
                </serviceos-ng-link>
            </div>
        </div>
    </div>
</div>
<ng-template #accountDeletionRequested>
    <serviceos-ng-alert class="error-alert" [type]="'error'" *ngIf="accountManagement$ | async as accountManagement">
        {{ accountManagement.confirmation_message }}
    </serviceos-ng-alert>
</ng-template>
